/* Homepage ritual quiz - behaviour. Owner: sections/kaayu-quiz.liquid (placed on templates/index.json) */

(function(){

  /* ═══ PRODUCTS ═══ */
  const KQ_PRODUCTS = {
    happyGut:   {name:'Happy Gut',              cat:'Inner Wellness',  em:'🌿',p:1150,d:'Triphala capsules for gut reset, reduced bloating, and microbiome restoration.',handle:'happy-gut-60-capsules'},
    wellNest:   {name:'Well Nest',              cat:'Inner Wellness',  em:'🛡️',p:1150,d:'Ashwagandha & Brahmi - lowers cortisol, builds immunity, restores energy.',handle:'well-nest-60-capsules'},
    detoxTea:   {name:'Calm & Detox Herbal Tea',cat:'Herbal Tea',      em:'🍵',p:525, d:'Adaptogenic herbal tea for daily gut-liver reset and sustained clean energy.',handle:'calm-detox-herbal-tea'},
    masazOil:   {name:'Masaz Hair Oil',         cat:'Root & Rise Hair',em:'🪷',p:1200,d:'Ayurvedic scalp oil for hair fall control and deep follicle nourishment.',handle:'masaz-hair-oil-100-ml'},
    loveSerum:  {name:'Love Hair Serum',        cat:'Root & Rise Hair',em:'💫',p:1500,d:'Lightweight serum - reduces frizz, strengthens roots, restores lustre.',handle:'love-hair-serum'},
    antiFlakey: {name:'Anti-Flakey Hair Serum', cat:'Root & Rise Hair',em:'❄️',p:1500,d:'Cooling scalp serum to eliminate dandruff and restore lasting scalp balance.',handle:'anti-flakey-hair-serum-50-ml'},
    brownRice:  {name:'Brown Rice Face Serum',  cat:'Sacred Skin',     em:'✨',p:2800,d:'Barrier-repair hydration serum - restores moisture and boosts radiance.',handle:'brown-rice-hydrating-face-serum-50-ml'},
    nightCream: {name:'Kumkumadi Night Cream',  cat:'Sacred Skin',     em:'🌙',p:3300,d:'Overnight Ayurvedic renewal cream - nourishes and illuminates while you sleep.',handle:'kumkumadi-night-cream-50-ml'},
    elixir:     {name:'HerMenoCalm',            cat:'Inner Wellness',  em:'🌺',p:999, d:'Shatavari & Ashwagandha for perimenopause and menopause support.',handle:'hermeno-calm'}
  };

  const KQ_WHY = {
    happyGut:   "Happy Gut's Triphala is Ayurveda's most trusted gut formulation - 5,000 years of clinical use.",
    wellNest:   "Well Nest's Ashwagandha clinically reduces cortisol and improves sleep quality within 8 weeks.",
    detoxTea:   "Calm & Detox Tea supports the gut-liver detox axis daily - the gentlest way to reset internal heat.",
    masazOil:   "Masaz Oil's Ayurvedic herbs penetrate the scalp to strengthen follicles and reduce shedding.",
    loveSerum:  "Love Serum seals hair cuticles - working in synergy with Masaz Oil for inner-outer hair repair.",
    antiFlakey: "Anti-Flakey Serum's cooling formula targets the scalp imbalance causing dandruff at its root.",
    brownRice:  "Brown Rice Serum clinically repairs the skin barrier - the #1 cause of dullness and dehydration.",
    nightCream: "Kumkumadi Night Cream works overnight - skin restores as deeply as your body does during sleep.",
    elixir:     "HerMenoCalm delivers Shatavari and adaptogens that synergise for compounded hormonal balance."
  };

  const KQ_STATE = {q1:new Set(),q2:'',q3:'',q4:new Set(),q5:'',q6:'',q7:''};
  let kqPickedProducts = [];
  const TOTAL_Q = 7;
  const PHASE_LABELS = ['','Symptoms & Concerns','Severity Rating','Body Constitution','Lifestyle Factors','Treatment History','Daily Routine','Your Investment'];

  function fmt(n){ return '₹'+n.toLocaleString('en-IN'); }

  /* ═══ PROGRESS ═══ */
  function kqUpdateProgress(q){
    document.getElementById('kqProgressFill').style.width = Math.round((q/TOTAL_Q)*100)+'%';
    document.getElementById('kqProgressCount').textContent = 'Question '+q+' of '+TOTAL_Q;
    document.getElementById('kqProgressLabel').textContent = PHASE_LABELS[q]||'';
  }

  function kqShowQ(n){
    for(let i=1;i<=7;i++){
      const el=document.getElementById('kqQ'+i);
      if(el) el.style.display=(i===n?'block':'none');
    }
    kqUpdateProgress(n);
    const wrap=document.getElementById('kqProgressWrap');
    if(wrap) wrap.scrollIntoView({behavior:'smooth',block:'start'});
  }

  /* ═══ SCORING ═══ */
  function kqScore(){
    // Algorithm lives in assets/kaayu-ritual-engine.js - shared with the
    // find-your-ritual page so both cannot drift apart. Do not reimplement here.
    return window.KaayuRitualEngine.score(KQ_STATE);
  }

  function kqPick(ranked){
    const limits={starter:1500,ritual:4000,complete:9999};
    const counts={starter:1,ritual:3,complete:5};
    const limit=limits[KQ_STATE.q7]||4000;
    const count=counts[KQ_STATE.q7]||3;
    const sel=[];let total=0;
    for(const k of ranked){
      if(sel.length>=count) break;
      if(total+KQ_PRODUCTS[k].p<=limit){sel.push(k);total+=KQ_PRODUCTS[k].p;}
    }
    return sel.length?sel:[ranked[0]];
  }

  function kqRitualMeta(){
    const c=[...KQ_STATE.q1];
    if(c.includes('gut')&&c.includes('skin'))    return{name:'Gut & Glow Ritual',tags:['Gut-Skin Axis','Radiance','Internal Cleanse'],desc:"Your skin and gut are speaking the same language. This ritual clears the internal root and unlocks the radiance internal imbalance has been suppressing."};
    if(c.includes('hair')&&c.includes('sleep'))  return{name:'Root & Rest Ritual',tags:['Cortisol Balance','Hair Strength','Deep Sleep'],desc:"Cortisol is stealing from both your sleep and your hair. This ritual lowers stress hormones and rebuilds hair follicle strength simultaneously."};
    if(c.includes('gut')&&c.includes('immunity'))return{name:'Gut Shield Ritual',tags:['Gut Immunity','Microbiome','Defence'],desc:"Your gut IS your immune system. This ritual rebuilds intestinal integrity and cellular immunity in one practice."};
    if(c.includes('gut'))    return{name:'Gut Harmony Ritual',tags:['Gut Health','Agni','Digestive Reset'],desc:"This ritual resets your Agni, clears Ama, and restores the inner balance your energy and skin depend on."};
    if(c.includes('sleep'))  return{name:'Deep Rest Ritual',tags:['Restful Sleep','Cortisol Reset','Calm'],desc:"Adaptogens that lower cortisol and botanicals that calm the nervous system - signaling your body to truly recover."};
    if(c.includes('hair'))   return{name:'Root & Rise Ritual',tags:['Hair Strength','Scalp Health','Root Care'],desc:"Inner and outer hair nourishment - addressing the gut-hair axis internally while restoring scalp health externally."};
    if(c.includes('skin'))   return{name:'Radiance Ritual',tags:['Natural Glow','Hydration','Skin Barrier'],desc:"A complete glow protocol - topical barrier repair, botanical illumination, and gut-driven clarity working in harmony."};
    if(c.includes('immunity'))return{name:'Vitality Shield',tags:['Immunity','Energy','Adaptogenic'],desc:"Fortify your defences with Ayurveda's most potent adaptogens - building deep immunity and cellular resilience."};
    if(c.includes('women'))  return{name:'Feminine Balance',tags:['Hormonal Balance','Cycle Support','Shatavari'],desc:"Shatavari, gut-hormone support, and skin nourishment - a ritual that honours your cycle and restores your equilibrium."};
    return{name:'Complete Wellness Ritual',tags:['Holistic','Inner+Outer','Ayurvedic'],desc:"A holistic Ayurvedic ritual built for multiple concerns - inner balance, outer radiance, and sustained wellbeing."};
  }

  function kqDiagnose(){
    const sym=[...KQ_STATE.q1],sev=parseInt(KQ_STATE.q2)||3,dsh=KQ_STATE.q3,lif=[...KQ_STATE.q4],hist=KQ_STATE.q5;
    const hasStress=lif.includes('stress'),hasDiet=lif.includes('diet'),hasHorm=lif.includes('hormonal')||sym.includes('women'),hasSleep=lif.includes('sleep_depri')||sym.includes('sleep'),isLong=hist==='long_term'||hist==='tried_products',isHigh=sev>=4;
    if(sym.includes('hair')&&hasStress&&hasSleep) return{title:'Root Cause: Cortisol-Driven Hair Loss',cause:'Your hair fall is stress-induced. Elevated cortisol pushes follicles into premature telogen phase. This is Telogen Effluvium - highly reversible with adaptogenic intervention and scalp support.'};
    if(sym.includes('hair')&&hasHorm)             return{title:'Root Cause: Hormonal Disruption & Hair Loss',cause:'Your hair fall is hormonal. Changes in oestrogen, progesterone, or androgens directly affect follicle function. Shatavari and adaptogenic support alongside scalp nourishment addresses both axes.'};
    if(sym.includes('skin')&&hasDiet&&dsh==='pitta') return{title:'Root Cause: Pitta Excess & Gut-Skin Imbalance',cause:"Your skin's dullness is driven by internal heat amplified by dietary triggers. In Ayurveda the gut-skin axis is direct - an imbalanced gut produces Ama that surfaces as dullness, breakouts, and uneven tone."};
    if(sym.includes('gut')&&hasStress)            return{title:'Root Cause: Stress-Disrupted Gut Microbiome',cause:'Elevated cortisol directly disrupts the gut microbiome and reduces digestive enzyme production. Adaptogens + targeted gut formulations address both simultaneously.'};
    if(sym.includes('immunity')&&hasDiet&&isHigh) return{title:'Root Cause: Compromised Gut Immunity',cause:'Your low immunity is rooted in gut dysfunction. 70% of your immune system lives in the gut. Rebuilding gut integrity is the fastest path to lasting immunity.'};
    if(hasHorm&&sym.includes('women'))            return{title:'Root Cause: Gut-Hormone Axis Dysregulation',cause:"The gut microbiome directly regulates oestrogen metabolism. When gut health is compromised this regulation fails - causing the hormonal imbalance showing up as irregular cycles, PMS, and skin changes."};
    if(sym.includes('sleep')&&hasStress&&dsh==='vata') return{title:'Root Cause: Vata Imbalance & Nervous System Dysregulation',cause:'Your sleep issues are classic Vata excess - an overactivated nervous system that cannot wind down. Brahmi and Ashwagandha work on the HPA axis, not just sedation.'};
    if(isLong&&isHigh) return{title:'Root Cause: Deep Chronic Multi-System Imbalance',cause:'This is a deep-seated multi-system imbalance. Your ritual needs to work on three levels: internal cleansing, tissue nourishment, and adaptogenic protection. Results emerge over 60–90 days.'};
    const t=sym.includes('gut')?'Agni Imbalance':sym.includes('hair')?'Scalp & Follicle Stress':sym.includes('skin')?'Gut-Skin Axis':'Internal Imbalance';
    return{title:'Root Cause: '+t,cause:"Your symptoms reflect an imbalance between internal health and external care. Your ritual addresses this from both directions."};
  }

  /* ═══ ADD TO CART ═══ */
  async function kqAddToCart(handles, btnEl, successEl){
    btnEl.disabled = true;
    btnEl.textContent = 'Adding…';
    try {
      // Fetch variant IDs for each handle
      const items = [];
      for(const handle of handles){
        const res = await fetch('/products/'+handle+'.js');
        const prod = await res.json();
        if(prod && prod.variants && prod.variants[0]){
          items.push({id: prod.variants[0].id, quantity: 1});
        }
      }
      if(items.length === 0) throw new Error('No variants found');

      // Add all to cart at once
      const cartRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items})
      });
      if(!cartRes.ok) throw new Error('Cart add failed');

      btnEl.textContent = '✓ Added to Bag';
      btnEl.style.background = '#166534';
      if(successEl){
        successEl.classList.add('show');
        successEl.textContent = '✓ '+(items.length > 1 ? items.length+' products' : '1 product')+' added to your bag!';
      }
    } catch(e){
      btnEl.disabled = false;
      btnEl.textContent = '🛍 Add Bundle to Bag';
      alert('Something went wrong. Please try again.');
    }
  }

  /* ═══ SHIPROCKET CHECKOUT ═══ */
  function kqTriggerCheckout(){
    if(window.shiprocketCheckoutEvents && window.shiprocketCheckoutEvents.buyNow){
      window.shiprocketCheckoutEvents.buyNow();
    } else {
      window.location.href = '/checkout';
    }
  }

  /* ═══ RENDER RESULTS ═══ */
  function kqRenderResults(){
    const meta   = kqRitualMeta();
    const ranked = kqScore();
    const picked = kqPick(ranked);
    kqPickedProducts = picked;
    const diag   = kqDiagnose();
    const total  = picked.reduce((s,k)=>s+KQ_PRODUCTS[k].p,0);
    const saved  = picked.length > 1 ? Math.round(total*0.15) : 0;
    const handles= picked.map(k=>KQ_PRODUCTS[k].handle);

    document.getElementById('kqRname').textContent  = meta.name;
    document.getElementById('kqRdesc').textContent  = meta.desc;
    document.getElementById('kqRtags').innerHTML    = meta.tags.map(t=>`<div class="kq-rtag">${t}</div>`).join('');
    document.getElementById('kqRcTitle').textContent = diag.title;
    document.getElementById('kqRcText').textContent  = diag.cause;

    const prodsHtml = picked.map(k=>{
    const p = KQ_PRODUCTS[k];
    return `<div class="kq-prod-row" id="kqrow-${k}">
        <span class="kq-prod-em">${p.em}</span>
        <div style="flex:1">
        <div class="kq-prod-cat">${p.cat}</div>
        <div class="kq-prod-name">${p.name}</div>
        <div class="kq-prod-desc">${p.d}</div>
        </div>
        <div class="kq-prod-price-col" style="display:flex;flex-direction:column;align-items:flex-end;gap:6px;flex-shrink:0;">
        <div class="kq-prod-price">${fmt(p.p)}</div>
        ${picked.length>1?`<button class="kq-btn-remove" data-key="${k}" style="background:#FEF2F2;border:1px solid #FECACA;color:#DC2626;font-size:11px;font-weight:600;padding:3px 9px;border-radius:6px;cursor:pointer;font-family:inherit;white-space:nowrap;">✕ Remove</button>`:''}
        </div>
    </div>`;
    }).join('');

    const whyHtml = `<div class="kq-why-card">
      <div class="kq-why-title">🌿 Why these products - based on your root cause</div>
      <div class="kq-why-grid">
        ${picked.map(k=>`<div class="kq-why-item"><span>🌱</span><span>${KQ_WHY[k]||''}</span></div>`).join('')}
      </div>
    </div>`;

    const pricingHtml = picked.length > 1 ? `
      <div class="kq-pricing-box">
        <div>
          <div class="kq-pr-was">Combined total: <s>${fmt(total)}</s></div>
          <div class="kq-pr-now">${fmt(total - saved)}</div>
          <div class="kq-pr-per">Avg. ${fmt(Math.round((total-saved)/30))}/day across all ${picked.length} products</div>
        </div>
        <div class="kq-pr-save">You save ${fmt(saved)}</div>
      </div>` : '';

    const ctaHtml = `
      <div class="kq-cta-block">
        <div class="kq-atb-success" id="kqAtbSuccess"></div>
        <button class="kq-btn-atb" id="kqBtnAtb" data-handles='${JSON.stringify(handles)}'>🛍 Add ${picked.length>1?'Bundle':'Product'} to Bag</button>
        <button class="kq-btn-checkout" id="kqBtnCheckout">⚡ Proceed to Checkout</button>
      </div>
      <div class="kq-micro-trust">
        <span class="kq-mt">🏅 AYUSH Certified</span>
        <span class="kq-mt">🌿 GMP Manufactured</span>
        <span class="kq-mt">🚚 Free shipping above ₹999</span>
        <span class="kq-mt">↩ 14-day returns</span>
        <span class="kq-mt">🔒 Secure checkout</span>
      </div>`;

    let html;
    if(picked.length === 1){
      const p = KQ_PRODUCTS[picked[0]];
      html = `<div class="kq-single-box">
        <div class="kq-prod-row" style="border:none;padding:0;margin-bottom:1rem">
          <span class="kq-prod-em" style="font-size:36px">${p.em}</span>
          <div style="flex:1">
            <div class="kq-prod-cat">${p.cat}</div>
            <div class="kq-prod-name" style="font-size:16px">${p.name}</div>
            <div class="kq-prod-desc">${p.d}</div>
          </div>
          <div class="kq-prod-price" style="font-size:1.2rem;color:#162B1E">${fmt(p.p)}</div>
        </div>
        ${ctaHtml}
      </div>
      ${whyHtml}`;
    } else {
      html = `<div class="kq-bundle-box">
        <div class="kq-bundle-head">
          <div class="kq-bundle-head-t">${meta.name} Bundle</div>
          <div class="kq-bundle-head-s">${picked.length} products · matched to your root cause${saved>0?' · Save '+fmt(saved):''}</div>
        </div>
        <div class="kq-bundle-body">
          ${prodsHtml}
          ${pricingHtml}
          ${ctaHtml}
        </div>
      </div>
      ${whyHtml}`;
    }

    document.getElementById('kqRcontent').innerHTML = html;

    // Wire Add to Cart button
    const atbBtn = document.getElementById('kqBtnAtb');
    const successEl = document.getElementById('kqAtbSuccess');
    if(atbBtn){
      atbBtn.addEventListener('click', function(){
        const h = JSON.parse(this.getAttribute('data-handles'));
        kqAddToCart(h, this, successEl);
      });
    }

    // Wire Checkout button
    const chkBtn = document.getElementById('kqBtnCheckout');
    if(chkBtn){
      chkBtn.addEventListener('click', kqTriggerCheckout);
    }
  }

  // Wire Remove buttons
    document.querySelectorAll('.kq-btn-remove').forEach(btn=>{
    btn.addEventListener('click', function(){
        const key = this.getAttribute('data-key');
        if(kqPickedProducts.length <= 1){
        alert('Your ritual needs at least one product!');
        return;
        }
        kqPickedProducts = kqPickedProducts.filter(k=>k!==key);
        // Re-render with updated bundle
        const meta = kqRitualMeta();
        const diag = kqDiagnose();
        const total = kqPickedProducts.reduce((s,k)=>s+KQ_PRODUCTS[k].p,0);
        const saved = kqPickedProducts.length > 1 ? Math.round(total*0.15) : 0;
        const handles = kqPickedProducts.map(k=>KQ_PRODUCTS[k].handle);

        document.getElementById('kqRname').textContent = meta.name;
        document.getElementById('kqRdesc').textContent  = meta.desc;
        document.getElementById('kqRtags').innerHTML = meta.tags.map(t=>`<div class="kq-rtag">${t}</div>`).join('');
        document.getElementById('kqRcTitle').textContent = diag.title;
        document.getElementById('kqRcText').textContent  = diag.cause;

        kqRenderResults();
    });
    });

  /* ═══ LOADING ANIMATION ═══ */
  function kqShowLoading(){
    document.getElementById('kqQ7').style.display='none';
    document.getElementById('kqProgressWrap').style.display='none';
    document.getElementById('kqLoading').style.display='block';
    const msgs=['Analysing your symptoms and body type…','Identifying your root cause…','Scoring Kaayu formulations…','Building your personalised ritual…'];
    let i=0;
    const iv=setInterval(()=>{
      const el=document.getElementById('kqLoadMsg');
      if(el&&i<msgs.length){ el.textContent=msgs[i++]; }
      else{
        clearInterval(iv);
        document.getElementById('kqLoading').style.display='none';
        kqRenderResults();
        document.getElementById('kqResults').style.display='block';
        document.getElementById('kqResults').scrollIntoView({behavior:'smooth',block:'start'});
      }
    },900);
  }

  /* ═══ LEAD POPUP ═══ */
  function kqShowLeadPopup(){
    document.getElementById('kqLeadPopup').style.display='flex';
  }

  function kqHideLeadPopup(){
    document.getElementById('kqLeadPopup').style.display='none';
  }

  function kqSubmitLead(e){
    e.preventDefault();
    const name  = document.getElementById('kqLeadName').value.trim();
    const phone = document.getElementById('kqLeadPhone').value.trim();
    const email = document.getElementById('kqLeadEmail').value.trim();
    const msg   = document.getElementById('kqLeadMsg').value.trim();

    // Validate
    let valid = true;
    document.querySelectorAll('.kq-err').forEach(el=>el.classList.remove('show'));

    if(!name){ document.getElementById('kqNameErr').classList.add('show'); valid=false; }
    if(!/^\d{10}$/.test(phone)){ document.getElementById('kqPhoneErr').classList.add('show'); valid=false; }
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ document.getElementById('kqEmailErr').classList.add('show'); valid=false; }
    if(!valid) return;

    const submitBtn = document.getElementById('kqLeadSubmit');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting…';

    // Build quiz summary for email body
    const symptoms  = [...KQ_STATE.q1].join(', ') || 'Not specified';
    const severity  = KQ_STATE.q2 || 'Not specified';
    const dosha     = KQ_STATE.q3 || 'Not specified';
    const lifestyle = [...KQ_STATE.q4].join(', ') || 'Not specified';
    const history   = KQ_STATE.q5 || 'Not specified';
    const time      = KQ_STATE.q6 || 'Not specified';
    const budget    = KQ_STATE.q7 || 'Not specified';

    const body = `New Kaayu Quiz Lead\n\nName: ${name}\nPhone: ${phone}\nEmail: ${email}\nMessage: ${msg||'None'}\n\n--- Quiz Answers ---\nSymptoms: ${symptoms}\nSeverity: ${severity}/5\nDosha: ${dosha}\nLifestyle: ${lifestyle}\nHistory: ${history}\nTime available: ${time}\nBudget: ${budget}`;

    // Submit to Shopify contact form
    const formData = new URLSearchParams();
    formData.append('form_type', 'contact');
    formData.append('utf8', '✓');
    formData.append('contact[name]', name);
    formData.append('contact[email]', email);
    formData.append('contact[phone]', phone);
    formData.append('contact[body]', body);

    fetch('/contact', {
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: formData.toString()
    }).catch(()=>{
      // Non-blocking - proceed even if submission fails
    }).finally(()=>{
      kqHideLeadPopup();
      kqShowLoading();
    });
  }

  /* ═══ RESTART ═══ */
  function kqRestart(){
    KQ_STATE.q1=new Set();KQ_STATE.q2='';KQ_STATE.q3='';KQ_STATE.q4=new Set();KQ_STATE.q5='';KQ_STATE.q6='';KQ_STATE.q7='';
    kqPickedProducts=[];
    document.getElementById('kqResults').style.display='none';
    document.getElementById('kqProgressWrap').style.display='block';
    document.getElementById('kqRcontent').innerHTML='';
    document.querySelectorAll('.kq-opt').forEach(b=>b.classList.remove('kq-sel'));
    document.querySelectorAll('.kq-scale-opt').forEach(b=>b.classList.remove('kq-sel'));
    ['kqQ1next','kqQ2next','kqQ3next','kqQ4next','kqQ5next','kqQ6next','kqQ7next'].forEach(id=>{
      const el=document.getElementById(id);
      if(el) el.disabled=true;
    });
    kqShowQ(1);
  }

  /* ═══ WIRE ALL EVENTS ═══ */
  function kqInit(){
    // Q1 multi
    document.querySelectorAll('.kq-opt[data-kqq="q1"]').forEach(btn=>{
      btn.addEventListener('click',function(){
        this.classList.toggle('kq-sel');
        KQ_STATE.q1.has(this.dataset.val)?KQ_STATE.q1.delete(this.dataset.val):KQ_STATE.q1.add(this.dataset.val);
        document.getElementById('kqQ1next').disabled=KQ_STATE.q1.size===0;
      });
    });
    // Q2 scale
    document.querySelectorAll('.kq-scale-opt[data-kqq="q2"]').forEach(btn=>{
      btn.addEventListener('click',function(){
        document.querySelectorAll('.kq-scale-opt[data-kqq="q2"]').forEach(b=>b.classList.remove('kq-sel'));
        this.classList.add('kq-sel');KQ_STATE.q2=this.dataset.val;
        document.getElementById('kqQ2next').disabled=false;
      });
    });
    // Q3
    document.querySelectorAll('.kq-opt[data-kqq="q3"]').forEach(btn=>{
      btn.addEventListener('click',function(){
        document.querySelectorAll('.kq-opt[data-kqq="q3"]').forEach(b=>b.classList.remove('kq-sel'));
        this.classList.add('kq-sel');KQ_STATE.q3=this.dataset.val;
        document.getElementById('kqQ3next').disabled=false;
      });
    });
    // Q4 multi
    document.querySelectorAll('.kq-opt[data-kqq="q4"]').forEach(btn=>{
      btn.addEventListener('click',function(){
        this.classList.toggle('kq-sel');
        KQ_STATE.q4.has(this.dataset.val)?KQ_STATE.q4.delete(this.dataset.val):KQ_STATE.q4.add(this.dataset.val);
        document.getElementById('kqQ4next').disabled=KQ_STATE.q4.size===0;
      });
    });
    // Q5
    document.querySelectorAll('.kq-opt[data-kqq="q5"]').forEach(btn=>{
      btn.addEventListener('click',function(){
        document.querySelectorAll('.kq-opt[data-kqq="q5"]').forEach(b=>b.classList.remove('kq-sel'));
        this.classList.add('kq-sel');KQ_STATE.q5=this.dataset.val;
        document.getElementById('kqQ5next').disabled=false;
      });
    });
    // Q6
    document.querySelectorAll('.kq-opt[data-kqq="q6"]').forEach(btn=>{
      btn.addEventListener('click',function(){
        document.querySelectorAll('.kq-opt[data-kqq="q6"]').forEach(b=>b.classList.remove('kq-sel'));
        this.classList.add('kq-sel');KQ_STATE.q6=this.dataset.val;
        document.getElementById('kqQ6next').disabled=false;
      });
    });
    // Q7
    document.querySelectorAll('.kq-opt[data-kqq="q7"]').forEach(btn=>{
      btn.addEventListener('click',function(){
        document.querySelectorAll('.kq-opt[data-kqq="q7"]').forEach(b=>b.classList.remove('kq-sel'));
        this.classList.add('kq-sel');KQ_STATE.q7=this.dataset.val;
        document.getElementById('kqQ7next').disabled=false;
      });
    });

    // Navigation
    document.getElementById('kqQ1next').addEventListener('click',()=>kqShowQ(2));
    document.getElementById('kqQ2back').addEventListener('click',()=>kqShowQ(1));
    document.getElementById('kqQ2next').addEventListener('click',()=>kqShowQ(3));
    document.getElementById('kqQ3back').addEventListener('click',()=>kqShowQ(2));
    document.getElementById('kqQ3next').addEventListener('click',()=>kqShowQ(4));
    document.getElementById('kqQ4back').addEventListener('click',()=>kqShowQ(3));
    document.getElementById('kqQ4next').addEventListener('click',()=>kqShowQ(5));
    document.getElementById('kqQ5back').addEventListener('click',()=>kqShowQ(4));
    document.getElementById('kqQ5next').addEventListener('click',()=>kqShowQ(6));
    document.getElementById('kqQ6back').addEventListener('click',()=>kqShowQ(5));
    document.getElementById('kqQ6next').addEventListener('click',()=>kqShowQ(7));
    document.getElementById('kqQ7back').addEventListener('click',()=>kqShowQ(6));

    // Q7 next → show lead popup instead of directly loading
    document.getElementById('kqQ7next').addEventListener('click', kqShowLeadPopup);

    // Lead popup events
    document.getElementById('kqLeadClose').addEventListener('click', kqHideLeadPopup);
    document.getElementById('kqLeadForm').addEventListener('submit', kqSubmitLead);

    // Close popup on backdrop click
    document.getElementById('kqLeadPopup').addEventListener('click', function(e){
      if(e.target === this) kqHideLeadPopup();
    });

    // Restart
    document.getElementById('kqBtnRestart').addEventListener('click', kqRestart);
  }

  // Safe init - works whether DOM is ready or not
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', kqInit);
  } else {
    kqInit();
  }

})();
